<div class="div-inicial">
  <div class="div-buttons">
    <p-button class="adicionar-clinica" label="Adicionar Clinica" (click)="handleAbrirModalCadastroClinica()" />
    <p-button class="botao-informacoes" (click)="handleMostrarInformacoes()" label="Info" />
  </div>
  <div class="div-cards">
    <p-card *ngFor="let clinica of listaDeClinicas" header="{{clinica.nomeClinica}}">
      <div (click)="handleAbrirModalConfiguracaoClinica(clinica)">
        <p class="m-0">
          {{clinica.clinicaId}}
        </p>
      </div>
      <i class="pi pi-times" title="Excluir Clinica" (click)="deletarClinica(clinica.id)"></i>
    </p-card>
  </div>
</div>


<p-dialog header="Cadastro de Clinica" [modal]="true" [(visible)]="visibilidadeModalCadastroClinica"
  [style]="{ width: '75rem', height:'50rem' }" (onHide)="handleExecutarAoFecharModalCadastroClinica()">
  <form class="form-cadastro-clinicas" [formGroup]="formularioInsercaoClinica">
    <span class="p-text-secondary block mb-5">Nome da Clinica.</span>
    <input type="text" pInputText formControlName="nomeClinica" />
    <span class="p-text-secondary block mb-5">ID da Clinica.</span>
    <input type="text" pInputText formControlName="clinicaId" />
    <span class="p-text-secondary block mb-5">App Access Token.</span>
    <input type="text" pInputText formControlName="appAccessToken" />
    <div class="config-line">

      <span class="p-text-secondary  mb-2" style="margin-left: 5px;">ID Fila:</span>
      <input type="text" pInputText formControlName="queueId" />
      <span class="p-text-secondary  mb-2" style="margin-left: 5px;">ApiKey:</span>
      <input type="text" pInputText formControlName="apiKey" />
      <span class="p-text-secondary  mb-2" style="margin-left: 5px;">Host:</span>
      <input type="text" pInputText formControlName="host" />
      <span class="p-text-secondary  mb-2" style="margin-left: 5px;">Horario:</span>
      <p-datepicker inputId="calendar-timeonly" [timeOnly]="true"
        title="Horario que vai iniciar a execucao da automacao" formControlName="horario" />
    </div>
    <span class="p-text-secondary block mb-5">D+ (para confirmacao de consulta)</span>
    <p-inputnumber inputId="integeronly" formControlName="somaDia" />
    <span class="p-text-secondary block mb-5">Mensagem de confirmacao de consulta.</span>
    <textarea rows="5" cols="30" pTextarea formControlName="mensagemConfirmacaoConsulta"></textarea>
    <span class="p-text-secondary block mb-5">Mensagem de lembrete de consulta.</span>
    <textarea rows="5" cols="30" pTextarea formControlName="mensagemLembreteConsulta"></textarea>

    <p-button label="Cadastrar" (click)="handleEnviarCadastroClinica()" [disabled]="!formularioInsercaoClinica.valid" />
  </form>
</p-dialog>

<p-dialog header="Informacoes Importantes" [modal]="true" [(visible)]="mostrarInformacoes" [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <p class="mb-8">
    <strong>Instrucoes de configuracao:</strong>
  </p>
  <p class="mb-8">
    Para utilizar alguma das variaveis na mensagem, deve-se utilizar entre chaves <br>
    Ex: <strong>{{ '{' }}nome_paciente{{ '}'}}</strong> para que na mensagem seja substituido pelo nome do paciente.
  </p>
  <hr>
  <p class="mb-8">
    <strong>Variaveis Disponiveis:</strong>
  </p>
  <p class="mb-8">
    nome_paciente - Referir na mensagem ao nome do paciente.
  </p>
  <p class="mb-8">
    data - Referir a data do agendamento da consulta.
  </p>
  <p class="mb-8">
    horario - Referir ao horario do agendamento da consulta.
  </p>
  <p class="mb-8">
    doutor - Referir ao Doutor responsavel pela consulta no agendamento.
  </p>
</p-dialog>

<ng-container *ngIf="clinicaSelecionada">
  <p-dialog header="Configuracoes da Clinica" [modal]="true" [(visible)]="visibilidadeModalConfiguracaoClinica"
    [style]="{ width: '75rem', height:'50rem' }" (onHide)="handleExecutarAoFecharModalConfiguracaoClinica()">
    <form class="form-cadastro-clinicas" [formGroup]="formularioEdicaoClinica">
      <span class="p-text-secondary block mb-5">Nome da Clinica.</span>
      <input type="text" pInputText formControlName="nomeClinica" />
      <span class="p-text-secondary block mb-5">ID da Clinica.</span>
      <input type="text" pInputText formControlName="clinicaId" />
      <span class="p-text-secondary block mb-5">App Access Token.</span>
      <input type="text" pInputText formControlName="appAccessToken" />
      <div class="config-line">

        <span class="p-text-secondary  mb-2" style="margin-left: 5px;">ID Fila:</span>
        <input type="text" pInputText formControlName="queueId" />
        <span class="p-text-secondary  mb-2" style="margin-left: 5px;">ApiKey:</span>
        <input type="text" pInputText formControlName="apiKey" />
        <span class="p-text-secondary  mb-2" style="margin-left: 5px;">Host:</span>
        <input type="text" pInputText formControlName="host" />
        <span class="p-text-secondary  mb-2" style="margin-left: 5px;">Horario:</span>
        <p-datepicker inputId="calendar-timeonly" [timeOnly]="true"
          title="Horario que vai iniciar a execucao da automacao" formControlName="horario" />
      </div>
      <span class="p-text-secondary block mb-5">D+ (para confirmacao de consulta)</span>
      <p-inputnumber inputId="integeronly" formControlName="somaDia" />
      <span class="p-text-secondary block mb-5">Mensagem de confirmacao de consulta.</span>
      <textarea rows="5" cols="30" pTextarea formControlName="mensagemConfirmacaoConsulta"></textarea>
      <span class="p-text-secondary block mb-5">Mensagem de lembrete de consulta.</span>
      <textarea rows="5" cols="30" pTextarea formControlName="mensagemLembreteConsulta"></textarea>

      <p-button label="Atualizar" (click)="handleEnviarAtualizacaoClinica()" />
    </form>
  </p-dialog>
</ng-container>

<app-loading-modal></app-loading-modal>
<app-alert></app-alert>